import { render, staticRenderFns } from "./seed_stock.vue?vue&type=template&id=9585fc24&scoped=true&"
import script from "./seed_stock.vue?vue&type=script&lang=js&"
export * from "./seed_stock.vue?vue&type=script&lang=js&"
import style0 from "./seed_stock.vue?vue&type=style&index=0&id=9585fc24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9585fc24",
  null
  
)

export default component.exports